var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00195312V341.991H513V-0.00195312H0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.688 141.421H279.207L256.5 71.5386L233.793 141.423H160.312L219.759 184.614L197.052 254.499L256.5 211.305L315.948 254.496L293.241 184.611L352.688 141.421ZM236.398 179.205L244.076 155.574H268.924L276.602 179.205V179.206L256.5 193.811L236.398 179.205ZM264.325 141.421H248.676L256.5 117.337L264.325 141.421ZM288.642 170.459L283.805 155.574H309.129L288.642 170.459ZM229.195 155.574L224.358 170.459L203.871 155.574H229.195ZM223.974 217.443L231.799 193.36L244.46 202.559L223.974 217.443ZM268.539 202.558L281.2 193.359L289.025 217.442L268.539 202.558Z",
    fill: "#20661B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMa);
export default __webpack_public_path__ + "static/media/MA.afd6c023e17d03fd2121593bb215dba3.svg";
export { ForwardRef as ReactComponent };